import React, { memo, useState, useEffect } from "react";

import Empty from "../../../empty";
import { getBanner } from "@/api/home";
import styles from "./style.module.less";
import { Carousel } from "antd";
import ImgComps from "../../../ImgComps";
import { Iprops } from "../..";
import { FocusSDK } from "@/utils";
import AIAssistant from "../../AIAssistant";

export interface bannerItem {
  pcImgUrl?: string | null;
  pcUrl: string | null;
  applicationBaseInfoList: {
    homeUrl: string;
    deploymentType: number;
    deepLink: string | null;
    eGovHomeUrl: string | null;
    hostAppClient: number;
  }[];
  applicationKey: string | null;
  linkType?: 1 | 2 | 3;
  urlType?: 1 | 2 | 3;
  mobileUrl: string | null;
  applicationId: string | null;
  applicationName: string;
  imgUrl?: string | null;
}
export interface bannerInterface {
  contentDtoList: bannerItem[];
  scrollInterval?: number;
}
const Banner = memo(({ onAppOrLinkClick, t }: Iprops) => {
  const [cur, setCur] = useState(0);
  const [scrollTimeInterval, setScrollTimeInterval] = useState(3);
  const [dynamicScroll, setDynamicScroll] = useState(false);
  const [bannerList, setBannerList] = useState<bannerItem[]>([]);
  const userData: any = {};
  useEffect(() => {
    getBanner()
      .then((res: bannerInterface) => {
        console.log("getBanner----res---", res?.contentDtoList);
        // 获取banner设置
        setBannerList(res?.contentDtoList || []);
        setScrollTimeInterval(res?.scrollInterval || 3);
        setDynamicScroll(res?.contentDtoList?.length > 1 ? true : false);
      })
      .catch((err) => {
        console.log("getBanner----err---", err);
      });
  }, []);

  const onChange = (e: any) => {
    setCur(e.target.current);
  };

  /**
   * @description: 跳转页面
   * @param {*} applicationId 应用 id
   * @param {*} urlType
   * @param {*} pcUrl  移动端跳转 url
   * @param {*} urlType   跳转链接类型；1：链接，取 pcUrl或 pcUrl  ；  2：应用，取applicationBaseInfoList里的应用信息
   * @param {*} applicationName
   * @return {*}
   */

  const onBannerClick = (item: any) => {
    console.log(item, "onBannerClick");
    onAppOrLinkClick({ ...item, urlType: item.linkType });
  };

  if (!bannerList?.length) return null;
  const ll = bannerList?.length || 0;
  return (
    <div className={styles.banner_wrapper}>
      <div className={styles.banner_content}>
        {
          <div>
            <Carousel
              className={styles.swiper}
              //  afterChange={onChange}
              dots
              //   indicatorDots={true}
              //   indicatorColor="#fff"
              //   indicatorActiveColor="#fff"
              autoplaySpeed={scrollTimeInterval * 1000}
              autoplay={dynamicScroll}
            >
              {!ll && <Empty />}
              {bannerList?.map((item: any) => (
                <div key={item?.applicationId}>
                  <ImgComps
                    src={item.pcImgUrl}
                    className={styles.swiper_item}
                    onClick={() => {
                      onBannerClick(item);
                    }}
                  />
                </div>
              ))}
            </Carousel>
          </div>
        }
      </div>
    </div>
  );
});

export default Banner;
